module.exports = __webpack_public_path__ + "media/V81.7c44955e.mp4";